module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "fm1"
    }
  }, [_c('em', [_vm._v("This book, though fictional in form, is based strictly on historical fact. Everything in it is real or actually happened. And it all began just one year from today.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("E. A.                      "), _c('br'), _vm._v("Wolf Hole, Arizona")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6231548c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_fm1_r1.vue
// module id = 66
// module chunks = 0